import axios from "axios";
import React, { useEffect, useState } from "react";
import { Line, Gap, ProgressBar, LabelTitle, LabelLevel, FooterReport } from "../../../../components/Global";
import { CONFIG_UTIL } from "../../../../config";
import Cookies from "js-cookie";
import utilManagement from "../../../../apis/utilManagement";
import LoaderModal from "../../../../components/modal/LoaderModal";

const ReportSiswa = (props) => {
    const [dataStudent, SetDataStudent] = useState([]);
    const [dataDetailAkademik, SetDataDetailAkademik] = useState([]);
    const [dataMapel, SetDataMapel] = useState([]);
    const [dataDetailNonAkademik, SetDataDetailNonAkademik] = useState([]);
    const [dataIndicatorLiterasi, SetDataIndicatorLiterasi] = useState([]);
    const [dataIndicatorNumerasi, SetDataIndicatorNumerasi] = useState([]);
    const patch = props.match.params.idSiswa + "/" + props.match.params.idJadwal + "/" + props.match.params.idSekolah + "/" + props.match.params.idKelas + "/" + props.match.params.idKelasParalel;

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;
    const [fetching, setFetching] = useState(false);
    const [correctLiterasi, SetCorrectLiterasi] = useState([]);
    const [correctNumerasi, SetCorrectNumerasi] = useState([]);

    useEffect(() => {
        // axios
        //     .get(
        //         CONFIG_UTIL.UTIL_MANAGEMENT_HOST +
        //             "/" +
        //             CONFIG_UTIL.REPORT_SISWA_AKM +
        //             patch,
        //         {
        //             headers: {
        //                 Accept: "application/json",
        //                 "Content-Type": "application/json",
        //                 Authorization: "Bearer " + Cookies.get("Set-Cookie"),
        //             },
        //         }
        //     )
        //     .then((result) => {
        //         const responseAPI = result.data;

        //         SetDataStudent(responseAPI);
        //         SetDataDetailAkademik(responseAPI.detailAkademik);
        //         SetDataMapel(responseAPI.dataMapel);
        //         SetDataDetailNonAkademik(responseAPI.dataNonAkademik.SK);
        //         SetDataIndicatorLiterasi(
        //             responseAPI.dataIndikator[0].indikator
        //         );
        //         SetDataIndicatorNumerasi(
        //             responseAPI.dataIndikator[1].indikator
        //         );

        //         console.log(responseAPI);
        //     })
        //     .catch((err) => {
        //         console.log("err => ", err);
        //     });

        const getDatas = async () => {
            setFetching(true);
            const response = await utilManagement.get(CONFIG_UTIL.REPORT_SISWA_AKM + patch, {});
            if (response) {
                if (response.data) {
                    document.title = response.data.siswa + " - " + response.data.kelas;

                    const responseAPI = response.data;

                    SetCorrectLiterasi(responseAPI.detailAkademik[0].jumlahBenar + responseAPI.detailAkademik[1].jumlahBenar + responseAPI.detailAkademik[2].jumlahBenar);
                    SetCorrectNumerasi(responseAPI.detailAkademik[3].jumlahBenar + responseAPI.detailAkademik[4].jumlahBenar + responseAPI.detailAkademik[5].jumlahBenar);
                    SetDataStudent(responseAPI);
                    SetDataDetailAkademik(responseAPI.detailAkademik);
                    SetDataMapel(responseAPI.dataMapel);
                    SetDataDetailNonAkademik(responseAPI.dataNonAkademik.SK);
                    SetDataIndicatorLiterasi(responseAPI.dataIndikator[0].indikator);
                    SetDataIndicatorNumerasi(responseAPI.dataIndikator[1].indikator);
                }
                setFetching(false);
            }
        };
        getDatas();
    }, []);

    require("./ReportSiswa.css");
    return (
        <div>
            <LoaderModal isFetching={fetching} />
            {/* page 1 */}
            <div className="report-page">
                <div className="cardLine">
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>01</span>
                        </div>
                        <div className="pnl-date">
                            Tanggal Tes : {dataStudent.tanggal}
                        </div>
                    </div>
                    <div className="header-first-page" style={{ padding: '0px' }}>
                        <div className="text-header" style={{ padding: '0px' }}>
                            <div className="title-header2" style={{ color: '#015E56' }}>REPORT SISWA</div>
                            <div className="label-sub-tit" style={{ width: '380px'}}>
                                <span className="sub-title-header" style={{ color: '#FFF' }}>Program Asesmen Nasional</span>
                            </div>
                        </div>
                        <div className="image-header">
                            <div className="logo-edu">
                                <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} />
                            </div>
                            <div className="logo-an">
                                <img src="/assets/image/LOGO_AN_2.png" width={"100%"} style={{ height: '33px', width: '148px' }} />
                            </div>
                        </div>
                    </div>
                    <div className="pnl-profile" style={{ marginTop: '3%' }}>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/mdi_person.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Nama Siswa</span>
                                <p className="label-profile-value">{dataStudent.siswa}</p>
                            </div>
                        </div>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/icon-kelas.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Kelas</span>
                                <p className="label-profile-value" style={{ verticalAlign: "middle" }}>{dataStudent.kelas}</p>
                            </div>
                        </div>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/icon-sekolah.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Sekolah</span>
                                <p className="label-profile-value">{dataStudent.sekolah}</p>
                            </div>
                        </div>
                    </div>
                    <div style={{ width: '100%', display: 'flex', gap: '20px' }}>
                        <div className="card-profile" style={{ width: '50%' }}>
                            <LabelTitle label={"Literasi"} size={28} />
                            <div style={{ width: '100%' }}>
                                {dataDetailAkademik.map((levelLiterasi, i) => {
                                    return (
                                        <div key={i} style={{ marginBottom: '20px' }}>
                                            {levelLiterasi.namaMapel == "LITERASI" ? (
                                                <ProgressBar
                                                    level={levelLiterasi.namaKategoriSubProfil == "AKM_LVL1" ? "Level 1" : levelLiterasi.namaKategoriSubProfil == "AKM_LVL2" ? "Level 2" : "Level 3"}
                                                    ratio={levelLiterasi.jumlahBenar + "/" + Math.round(levelLiterasi.jumlahBenar + levelLiterasi.jumlahSalah)}
                                                    progressValue={(levelLiterasi.jumlahBenar / Math.round(levelLiterasi.jumlahBenar + levelLiterasi.jumlahSalah)).toFixed(2) * 100}
                                                    progressColor={levelLiterasi.namaKategoriSubProfil == "AKM_LVL1" ? "#FF3838" : levelLiterasi.namaKategoriSubProfil == "AKM_LVL2" ? "#03C46B" : "#0097CE"}
                                                    heightBar={23}
                                                />
                                            ) : null}
                                        </div>
                                    );
                                })}
                            </div>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', gap: '30px' }}>
                                <span style={{ fontSize: '18px', fontWeight: '700' }}>Total Benar</span>
                                <span style={{ fontSize: '18px', fontWeight: '700' }}>{correctLiterasi}</span>
                            </div>
                            <div className="card-tbl-indikator">
                                <div
                                    style={{
                                        display: "inline-block",
                                        width: "100%",
                                        marginBottom: 1,
                                        backgroundColor: "#BEF264",
                                        border: "#E9ECEF 1px solid",
                                        borderTopLeftRadius: 14,
                                        borderTopRightRadius: 14,
                                        padding: "10px",
                                    }}
                                >
                                    <div style={{ display: "inline-block", width: "25%", paddingLeft: 5, textAlign: 'left', fontSize: '16px', fontWeight: 600 }}>Indikator</div>
                                    <div style={{ display: "inline-block", width: "75%", textAlign: 'right', fontSize: '16px', fontWeight: 600 }}>Ketuntasan</div>
                                </div>
                                <table className="table table-hover">
                                    <tbody>
                                        {dataIndicatorLiterasi.map((indicatorLiterasi, i) => {
                                            return (
                                                <tr>
                                                    <td>
                                                        <LabelTitle label={indicatorLiterasi.namaIndikator} size={16} bolder={300} color={"#6C757D"} />
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <div style={{ display: 'flex', justifyContent: 'right' }}>
                                                            {indicatorLiterasi.tuntas == true ? (
                                                                <div className="label-tuntas-green">
                                                                    <span>TUNTAS</span>
                                                                </div>)
                                                                : (
                                                                    <div className="label-tuntas-red">
                                                                        <span>TIDAK TUNTAS</span>
                                                                    </div>)
                                                            }
                                                        </div>

                                                    </td>
                                                </tr>
                                            );
                                        })}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="card-profile" style={{ width: '50%' }}>
                            <LabelTitle label={"Numerasi"} size={28} />
                            <div style={{ width: '100%' }}>
                                {dataDetailAkademik.map((levelNumerasi, i) => {
                                    return (
                                        <div key={i} style={{ marginBottom: '13px' }}>
                                            {levelNumerasi.namaMapel == "NUMERASI" ? (
                                                <ProgressBar
                                                    level={levelNumerasi.namaKategoriSubProfil == "AKM_LVL1" ? "Level 1" : levelNumerasi.namaKategoriSubProfil == "AKM_LVL2" ? "Level 2" : "Level 3"}
                                                    ratio={levelNumerasi.jumlahBenar + "/" + Math.round(levelNumerasi.jumlahBenar + levelNumerasi.jumlahSalah)}
                                                    progressValue={(levelNumerasi.jumlahBenar / Math.round(levelNumerasi.jumlahBenar + levelNumerasi.jumlahSalah)).toFixed(2) * 100}
                                                    progressColor={levelNumerasi.namaKategoriSubProfil == "AKM_LVL1" ? "#FF3838" : levelNumerasi.namaKategoriSubProfil == "AKM_LVL2" ? "#03C46B" : "#0097CE"}
                                                    heightBar={25}
                                                />
                                            ) : null}
                                        </div>
                                    );
                                })}
                            </div>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', gap: '30px' }}>
                                <span style={{ fontSize: '18px', fontWeight: '700' }}>Total Benar</span>
                                <span style={{ fontSize: '18px', fontWeight: '700' }}>{correctNumerasi}</span>
                            </div>
                            <div className="card-tbl-indikator">
                                <div
                                    style={{
                                        display: "inline-block",
                                        width: "100%",
                                        marginBottom: 1,
                                        backgroundColor: "#BEF264",
                                        border: "#E9ECEF 1px solid",
                                        borderTopLeftRadius: 14,
                                        borderTopRightRadius: 14,
                                        padding: "10px",
                                    }}
                                >
                                    <div style={{ display: "inline-block", width: "25%", paddingLeft: 5, textAlign: 'left', fontSize: '16px', fontWeight: 600 }}>Indikator</div>
                                    <div style={{ display: "inline-block", width: "75%", textAlign: 'right', fontSize: '16px', fontWeight: 600 }}>Ketuntasan</div>
                                </div>
                                <table className="table table-hover">
                                    <tbody>
                                        {dataIndicatorNumerasi.map((indicatorNumerasi, i) => {
                                            return (
                                                <tr>
                                                    <td>
                                                        <LabelTitle label={indicatorNumerasi.namaIndikator} size={16} bolder={300} color={"#6C757D"} />
                                                    </td>
                                                    <td style={{ textAlign: 'right' }}>
                                                        <div style={{ display: 'flex', justifyContent: 'right' }}>
                                                            {indicatorNumerasi.tuntas == true ? (
                                                                <div className="label-tuntas-green">
                                                                    <span>TUNTAS</span>
                                                                </div>)
                                                                : (
                                                                    <div className="label-tuntas-red">
                                                                        <span>TIDAK TUNTAS</span>
                                                                    </div>)
                                                            }
                                                        </div>

                                                    </td>
                                                </tr>
                                            );
                                        })}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* page 2 */}
            <div className="report-page">
                <div className="cardLine">
                    <div className="pnl-header">
                        <div className="card-page">
                            <span style={{
                                fontSize: '26px',
                                color: '#FFF',
                                fontWeight: 500,
                                fontFamily: 'lucida grande'
                            }}>02</span>
                        </div>
                        <div className="pnl-date">
                            Tanggal Tes : {dataStudent.tanggal}
                        </div>
                    </div>
                    <div className="header-first-page" style={{ padding: '0px' }}>
                        <div className="text-header" style={{ padding: '0px' }}>
                            <div className="title-header2" style={{ color: '#015E56' }}>REPORT SISWA</div>
                            <div className="label-sub-tit" style={{ width: '380px'}}>
                                <span className="sub-title-header" style={{ color: '#FFF' }}>Program Asesmen Nasional</span>
                            </div>
                        </div>
                        <div className="image-header">
                            <div className="logo-edu">
                                <img src="https://eduprime.co.id/static/images/LOGO_EDUPRIME_2.png" width={"100%"} />
                            </div>
                            <div className="logo-an">
                                <img src="/assets/image/LOGO_AN_2.png" width={"100%"} style={{ height: '33px', width: '148px' }} />
                            </div>
                        </div>
                    </div>
                    <div className="card-profile" style={{ marginTop: '5%' }}>
                        <div style={styles.indicatorLabel}>
                            <LabelTitle label={"Hasil Asesmen Kompetensi Minimum"} size={24} bolder={600} />
                        </div>
                        <Gap height={15} />
                        {dataMapel.map((mapel, i) => {
                            return (
                                <div key={i} style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                                        <LabelTitle label={mapel.namaMataPelajaran} size={20} bolder={400} />
                                        {/* <div ></div> */}
                                        <LabelLevel
                                            level={mapel.kategori.nama}
                                            color={'#FFF'}
                                            bgColor={mapel.kategori.nama === "Dasar" ? "#FEBC04" : mapel.kategori.nama === "Cakap" ? "#0097CE" : mapel.kategori.nama === "Mahir" ? "#03C46B" : "#FF3838"}
                                        />
                                    </div>
                                    <Gap height={5} />
                                    <LabelTitle size={16} bolder={200} color={"#6C757D"} label={mapel.kategori.deskripsi} />
                                    <Gap height={15} />
                                </div>
                            );
                        })}
                    </div>
                    <div className="card-profile" style={{ marginTop: '20px' }}>
                        <div style={styles.indicatorLabel}>
                            <LabelTitle label={"Hasil Dan Analisis Survei Karakter"} size={24} bolder={600} />
                        </div>
                        <div style={{ width: '100%', marginTop: '20px' }}>
                            {dataDetailNonAkademik.map((dataSK, i) => {
                                return (
                                    <div key={i}>
                                        <div style={{ width: '100%', display: 'flex', gap: '20px', margin: '10px 0' }}>
                                            <div className="section-four-left" style={{ width: '5%', display: 'flex', alignItems: 'center' }}>
                                                <div>
                                                    <img
                                                        src={
                                                            dataSK.aspek === "Kreatif"
                                                                ? "/assets/image/mdi_lightbulb.svg"
                                                                : dataSK.aspek === "Gotong Royong"
                                                                    ? "/assets/image/mdi_people.svg"
                                                                    : dataSK.aspek === "Bernalar Kritis"
                                                                        ? "/assets/image/mdi_hub.svg"
                                                                        : dataSK.aspek === "Mandiri"
                                                                            ? "/assets/image/mdi_mandiri.svg"
                                                                            : dataSK.aspek === "Berkebhinekaan Global"
                                                                                ? "/assets/image/mdi_religion-islamic.svg"
                                                                                : "/assets/image/mdi_earth.svg"
                                                        }
                                                        width={"35px"}
                                                    />
                                                </div>
                                            </div>
                                            <div className="section-four-center" style={{ width: '90%' }}>
                                                <div>
                                                    <div className="section-four-center-left">
                                                        <LabelTitle size={16} bolder={500} color={"#212529"} label={dataSK.aspek} />
                                                    </div>
                                                    <div className="section-four-center-right" style={{ marginTop: '10px' }}>
                                                        <ProgressBar progressColor={"#BEF264"} progressValue={dataSK.skor} heightBar={25} />
                                                    </div>
                                                </div>
                                                <LabelTitle size={16} bolder={200} color={"#6C757D"} label={dataSK.deskripsi} />
                                            </div>
                                            <div className="section-four-right" style={{ width: '10%', display: 'flex', alignItems: 'center' }}>
                                                <div style={{width: '100%', paddingTop: '16px'}}>
                                                    <LabelLevel
                                                        color={'#FFF'}
                                                        bgColor={'#03C46B'}
                                                        level={dataSK.kategori} style={{ with: '100%' }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            {/* End :: Page Two */}
            <div style={styles.fixedButton}>
                <button className="buttonPrint" onClick={() => window.print()}>
                    <img src="/assets/image/print.png" width={22} style={{ marginRight: 5 }} />
                    Print Report
                </button>
            </div>
        </div>
    );
};

export default ReportSiswa;

const styles = {
    resultBar: {
        display: "inline-block",
        width: "85%",
        textAlign: "right",
        fontWeight: 700,
        // marginTop: 10,
    },
    valueResultBar: {
        display: "inline-block",
        width: "15%",
        textAlign: "right",
        fontWeight: 700,
        // marginTop: 10,
    },
    indicatorBg: {
        backgroundColor: "#ccd1e4",
        borderRadius: "10px",
        padding: "12px",
        marginBottom: 10,
    },
    indicatorLabel: {
        display: "inline-block",
        width: "50%",
    },
    indicatorType: {
        display: "inline-block",
        width: "50%",
        textAlign: "right",
    },
    indicatorValue: {
        display: "inline-block",
        width: "85%",
    },
    indicatorStatus: {
        display: "inline-block",
        width: "15%",
    },
    paddingHorizontal: {
        paddingLeft: "12px",
        paddingRight: "12px",
    },
    fixedButton: {
        position: "fixed",
        bottom: "20px",
        right: "0px",
        height: "auto",
        padding: "15px",
        zIndex: 99,
        // -webkit-transform: translate3d(0, 0, 0),
        transition: "all 0.25s ease",
        textAlign: "center",
    },
};
